// Mock data for DaMarkas McNeese recruiting portfolio
// This will be replaced by backend API in later phase

export const player = {
  firstName: "DaMarkas",
  lastName: "McNeese",
  jerseyNumber: "20",
  positions: ["DE", "DT", "OT"],
  classOf: "2031",
  school: "Fishers Junior High",
  state: "Indiana",
  futureSchool: "Fishers High School Tigers",
  heightCurrent: '5\'9"',
  heightProjected: '6\'5"',
  weight: "215 lbs",
  gpa: "3.16",
  tagline: "Relentless Two-Way Lineman · Elite Sack Production",
  bio: "Explosive two-way defensive lineman out of Fishers Junior High (IN). Standing 5'9\", 215 lbs with a projected 6'5\" frame, DaMarkas combines leverage and raw power to dominate the interior, and brings edge-rushing speed when lined up outside. High-motor, technique-obsessed, and built for the next level — modeled after Aaron Donald (leverage & power) and Myles Garrett (speed & edge).",
  playstyle: [
    { name: "Aaron Donald", trait: "Leverage & Power" },
    { name: "Myles Garrett", trait: "Speed & Edge" },
  ],
  contactEmail: "damarkas24@gmail.com",
  recruitingEmail: "dmcneese11@icloud.com",
  coachName: "Coach Modglin",
  coachRole: "Head Coach · Fishers Junior High",
  coachEmail: "tmodglin@hse.k12.in.us",
};

export const seasonStats = {
  season: "2025–2026 Season",
  items: [
    { label: "Sacks", value: 9 },
    { label: "Tackles", value: 12 },
    { label: "Forced Fumbles", value: 1 },
    { label: "Fumble Recoveries", value: 1 },
  ],
};

export const measurables = [
  { label: "Height (Current)", value: '5\'9"' },
  { label: "Height (Projected)", value: '6\'5"' },
  { label: "Weight", value: "215 lbs" },
  { label: "Class", value: "2031" },
  { label: "Positions", value: "DE / DT / OT" },
  { label: "GPA", value: "3.16" },
];

export const accolades = [
  {
    year: "2025",
    title: "Mudsock Game Defensive Standout",
    description: "Named defensive standout at the historic Mudsock rivalry game.",
  },
  {
    year: "2026",
    title: "FBU Indianapolis Invite",
    description: "Invited to compete at Football University — Indianapolis camp.",
  },
  {
    year: "2025",
    title: "Two-Way Starter — FJH",
    description: "Starting both defensive line and offensive line for Fishers Junior High.",
  },
  {
    year: "Future",
    title: "Fishers High School Tiger",
    description: "Committed future varsity player for the Fishers HS Tigers program.",
  },
];

export const highlightVideo = {
  title: "DaMarkas McNeese — 2025 Defensive Highlights",
  youtubeId: "89udWjXZ8II",
  url: "https://youtu.be/89udWjXZ8II",
  duration: "Season Reel",
};

export const campVideo = {
  title: "FBU Camp Highlights",
  youtubeId: "kHKxe7i08L8",
  url: "https://youtu.be/kHKxe7i08L8",
  duration: "FBU Indianapolis",
};

export const socialLinks = [
  {
    name: "Instagram",
    handle: "@mar.be.tr1pin",
    url: "https://www.instagram.com/mar.be.tr1pin",
    platform: "instagram",
  },
  {
    name: "X / Twitter",
    handle: "@damarkas4",
    url: "https://x.com/damarkas4",
    platform: "x",
  },
];

export const gallery = [
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_damarkas-defense/artifacts/wa7bzqtj_IMG_1230.jpeg",
    caption: "Gameday · Trackside Warmup",
  },
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_damarkas-defense/artifacts/r6l8cugc_IMG_6315.jpeg",
    caption: "Fishers #6 · Suited Up",
  },
  {
    id: 3,
    src: "https://customer-assets.emergentagent.com/job_damarkas-defense/artifacts/62usfnzv_IMG_3178.jpeg",
    caption: "#20 · CC4L",
  },
];

export const academics = {
  gpa: "3.16",
  school: "Fishers Junior High",
  graduation: "Class of 2031",
  focus: ["Student-Athlete", "Disciplined", "Team-First Mentality"],
};

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Stats", href: "#stats" },
  { label: "Film", href: "#film" },
  { label: "Accolades", href: "#accolades" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];
